import React, { useState } from "react";
import axios from "axios";
import appConstant from "./shared/constant/constant.json";

const CouponSection = ({ orderSubtotal, onCouponApplied, onCouponRemoved }) => {
  const [couponValues, setCouponValues] = useState({
    couponCode: "",
  });
  const [couponApplied, setCouponApplied] = useState(false);
  const [couponMessage, setCouponMessage] = useState("");
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);
  const [couponDetails, setCouponDetails] = useState(null);

  const handleCouponChange = (e) => {
    const { name, value } = e.target;
    setCouponValues({ ...couponValues, [name]: value });
  };

  const applyCoupon = async () => {
    if (!couponValues.couponCode.trim()) {
      setCouponMessage("Please enter a coupon code");
      return;
    }

    setIsApplyingCoupon(true);
    setCouponMessage("");

    try {
      const formData = new FormData();
      formData.append("coupon_name", couponValues.couponCode);
      formData.append("sub_total", orderSubtotal);

      const response = await axios.post(
        `${appConstant.API_URL}/coupon`,
        formData
      );

      if (response.data.status === 200) {
        const discount = response.data.data.discount;
        setCouponApplied(true);
        setCouponDetails(response.data.data);
        setCouponDiscount(discount);
        setCouponMessage(
          response.data.message || "Coupon applied successfully!"
        );
        onCouponApplied(discount, response.data.data);
      } else {
        setCouponApplied(false);
        setCouponMessage(response.data.message || "Invalid coupon code");
      }
    } catch (error) {
      setCouponApplied(false);
      setCouponMessage(
        error.response?.data?.message || "Error applying coupon"
      );
    } finally {
      setIsApplyingCoupon(false);
    }
  };

  const removeCoupon = () => {
    setCouponApplied(false);
    setCouponValues({ couponCode: "" });
    setCouponMessage("");
    setCouponDiscount(0);
    setCouponDetails(null);
    onCouponRemoved();
  };

  return (
    <div className="coupon-section">
      <h6 className="title">APPLY COUPON</h6>
      <div className="coupon-input-container">
        <input
          className="coupon-input"
          type="text"
          placeholder="Enter coupon code"
          name="couponCode"
          value={couponValues.couponCode}
          onChange={handleCouponChange}
          disabled={couponApplied}
        />
        <button
          className="coupon-button"
          type="button"
          onClick={couponApplied ? removeCoupon : applyCoupon}
          disabled={isApplyingCoupon}
        >
          {isApplyingCoupon
            ? "Applying..."
            : couponApplied
            ? "Remove"
            : "Apply"}
        </button>
      </div>
      {couponMessage && (
        <div
          className={`coupon-message ${couponApplied ? "success" : "error"}`}
        >
          {couponMessage}
        </div>
      )}
    </div>
  );
};

export default CouponSection;
